import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
	Accordion,
	AccordionHeading,
	AccordionHeadingP,
	AccordionHeadingSpan,
	AccordionContent,
	AccordionHeadingContainer,
	AccordionHeadingContainerP
} from './styles';

export function AccordionTable({ nfActive, setNfActive, nota, indexLista }) {
	const [indexClick, setIndexClick] = useState('vazio');
	return (
		<Accordion className='accordion'>
			<AccordionHeading className='accordionHeading'>
				<AccordionHeadingContainer
					style={{ cursor: nota.length > 1 ? 'pointer' : '' }}
					onClick={() => {
						if (nota.length > 1) {
							if (indexClick === 'vazio') {
								setIndexClick(indexLista)
							} else {
								setIndexClick('vazio')
							}
							setNfActive(!nfActive)
						}
					}}
					className='container'>
					<AccordionHeadingP>{nota[0]}</AccordionHeadingP>
					{nota.length > 1 &&
						(
							indexClick === 'vazio' ?
								<AccordionHeadingSpan><ExpandMoreIcon /></AccordionHeadingSpan>
								:
								<AccordionHeadingSpan><ExpandLessIcon /></AccordionHeadingSpan>
						)}
				</AccordionHeadingContainer>
			</AccordionHeading>
			<AccordionContent className={`${indexLista === indexClick ? 'show' : ''} accordionContent`}>
				<AccordionHeadingContainerP>
					{nota.map((item, index) => (
						<>
							{index !== 0 ?
								<AccordionHeadingP>
									{item}
								</AccordionHeadingP>
								:
								<></>
							}
						</>
					))}
				</AccordionHeadingContainerP>
			</AccordionContent>
		</Accordion>
	)
}
